import { render } from "./FooterComponent.vue?vue&type=template&id=5d10f708&scoped=true"
import script from "./FooterComponent.vue?vue&type=script&lang=js"
export * from "./FooterComponent.vue?vue&type=script&lang=js"

import "./FooterComponent.vue?vue&type=style&index=0&id=5d10f708&scoped=true&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d10f708"]])

export default __exports__